import { Button, Divider } from "@material-ui/core";
import React, { useState } from "react";

const CallCenterSettings = () => {
  const [settings, setSettings] = useState({
    gameCutOffTime: 8,
    wagerTimeLimit: 60,
    clientNoActionLimit: 60,
    preCallTimer: 30,
    callThreshold: 1,
    useSoundRecording: false,
  });

  const [options, setOptions] = useState([
    { name: "Allow simultaneous login", checked: true },
    { name: "Clerk must type the player's code", checked: false },
    { name: "Disable credit features", checked: false },
    { name: "Hide offboard games", checked: false },
    { name: "Recalculate amount for IF-Bets", checked: false },
    { name: "Show default lines", checked: false },
    { name: "Use default phone line", checked: false },
  ]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : Number(value),
    }));
  };

  const handleCheckboxChange = (index) => {
    setOptions((prev) => {
      const updated = [...prev];
      updated[index].checked = !updated[index].checked;
      return updated;
    });
  };

  return (
    <div className="MuiTable-root2">
      <h2>Call Center Settings</h2>
      <Divider className="mt-4 mb-4"></Divider>
        <div className="p-4 border rounded-lg bg-gray-50 w-full">
        
        <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">

                <div className="flex gap-1 items-end">
                    <div className="w-1/2">
                        <label className="font-semibold mb-1 text-xs">Game Cut Off Time:</label>
                        <input
                            type="number"
                            name="gameCutOffTime"
                            value={settings.gameCutOffTime}
                            onChange={handleInputChange}
                            className="border p-1 w-full h-[30px] text-xs"
                            />
                    </div>
                    <p className="text-xs w-1/2">Minutes to place bets once the game time is reached.</p>
                </div>
                <div className="flex gap-1 items-end">
                    <div className="w-1/2" >
                        <label className="font-semibold mb-1 text-xs">Wager Time Limit:</label>
                        <input
                            type="number"
                            name="wagerTimeLimit"
                            value={settings.wagerTimeLimit}
                            onChange={handleInputChange}
                            className="border p-1 w-full h-[30px] text-xs"
                        />
                    </div>
                    <p className="text-xs w-1/2">Minutes that bets can be in the Open Wager box.</p>
                </div>
                <div className="flex gap-1 items-end">
                    <div className="w-1/2">
                        <label className="font-semibold mb-1 text-xs">Client No Action Limit:</label>
                        <input
                            type="number"
                            name="clientNoActionLimit"
                            value={settings.clientNoActionLimit}
                            onChange={handleInputChange}
                            className="border p-1 w-full h-[30px] text-xs"
                        />
                    </div>
                    <p className="text-xs w-1/2">Minutes that the account can be open.</p>
                </div>
            </div>
            <div className="border flex justify-center flex-col gap-1 bg-white rounded-md p-3">
            {options.map((opt, index) => (
                <div key={index} className="flex items-center gap-2">
                <input
                    type="checkbox"
                    checked={opt.checked}
                    onChange={() => handleCheckboxChange(index)}
                />
                <span className="text-xs">{opt.name}</span>
                </div>
            ))}
            </div>
            
        </div>
        
        <div className="mt-4">
            <h3 className="font-semibold">Calls Recording</h3>
            <div className="flex gap-4">
            <div>
                <label className="font-semibold mb-1 text-xs">Pre Call Timer</label>
                <input
                type="number"
                name="preCallTimer"
                value={settings.preCallTimer}
                onChange={handleInputChange}
                className="border p-1 w-full"
                />
            </div>
            <div>
                <label className="font-semibold mb-1 text-xs">Call Threshold</label>
                <input
                type="number"
                name="callThreshold"
                value={settings.callThreshold}
                onChange={handleInputChange}
                className="border p-1 w-full"
                />
            </div>
            <div className="flex items-center gap-2">
                <input
                type="checkbox"
                name="useSoundRecording"
                checked={settings.useSoundRecording}
                onChange={handleInputChange}
                />
                <label className="font-semibold mb-1 text-xs">Use Sound Recording</label>
            </div>
            </div>
        </div>
        
        </div>
        <Button
            size="small"
            variant="contained"
            className="!flex ml-auto mr-0 mt-2 " 
        >
            Last Changes
        </Button>
    </div>
  );
};

export default CallCenterSettings;